import styled from 'styled-components';
import getImagePath from '../CommonUtils/getImagePath';

// eslint-disable-next-line import/prefer-default-export
export const Icon = styled.span`
  font-size: 24px;
  opacity: 0.55;
  margin-right: 5px;
  display: inline;
  vertical-align: sub;
  color: #000;

  &.fa-health_care:after,
  &.fa-retirement:after {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-size: cover;
    background-position: center;
    content: '';
  }

  &.fa-health_care:after {
    background-image: url(${getImagePath('wizard/goals/health_care.png')});
  }

  &.fa-retirement:after {
    width: 30px;
    height: 30px;
    position: relative;
    bottom: -5px;
    background-image: url(${getImagePath('multi_workflows/Retirement-black.png')});
  }
`;
